import React from "react";
import ContactSection from "../components/home/ContactSection";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
const ContactPage = () => {
  return (
    <div>
    <Navbar />
    {/* <div style={{ paddingTop: "100px" }}> */}
      <h1>fine</h1>
      <ContactSection />
    {/* </div> */}
    <Footer />
    </div>
  );
};

export default ContactPage;
